import React, { useContext, useState, useEffect } from "react";
// import { OrdersContext } from '../context/orders.context';
import { processType } from "../../utils/constant";
import moment from "moment";
import ChatButton from "../../Chat/ChatButton";
import { ChatRefContext } from "../../context/chatRef.context";
import Chat from "../../Chat/index";
import { currencyFormatter, isShowPriceAccordingToProcess } from "../../utils/helper";
import tickwhite from "../../images/tick-white.svg";
import teamImage from "../../images/group-svgrepo-com.svg";
import editImage from "../../images/edit.svg";
import downloadImage from "../../images/download.png";
import { Modal as AntModal } from "antd";
import {
  downloadPdf,
  handleCommonDeleteAddressForUser,
} from "../../utils/actions/allactions";
import { Modal, Button, Form, Dropdown, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import { config } from "../../environment/development";
import { Link } from "react-router-dom";
import redCancelImage from "../../images/close_red.svg";
import tickGreenImage from "../../images/tick-green.svg";
import { handleProjectNameChange } from "../../utils/actions/commanActions";
import TeamCollaboration from "../TeamCollaboration/TeamCollaboration";
import GlobalProjectNameComponent from "../GlobalProjectNameComponent/index";
import { BrainMachine, CalenderIcon, DownloadIcon, LucidLoader, UserIcon } from "../Icons"; 
import moreIcon from "../../images/dots.svg";
import { checkGenericUser } from "../../utils/actions/userActions";
import DownloadQuotationModal from "../DownloadQuotationComponent/DownloadQuotationModal";


const widthBasedOnStatus = {
  'all-quote-tab': 240,
  'inprogress': 180,
  'ready-to-order': 190,
  'submit-target-cost': 240,
  'completed': 190,
  'cancelled': 240,
};

const MyQuoteTable = (props) => {

  let token = localStorage.getItem("Token");
  const {
    quotationsList,
    selectedShipMethodMap,
    myQuotesDispatch,
    MY_QUOTE_ACTIONS,
    addressValues,
    setAddressValues,
    setShowAddressModal,
    setIsEdit,
    setEditId,
    fetchQuotesForUser,
    myQuotesState,
    versionData,
    activeTab,
  } = props;
  console.log("Active Tab :", activeTab);
  const { selectedChatRefId, setSelectedChatRefId } =
    useContext(ChatRefContext);
  const [teamMemberModalShow, setTeamMemberModalShow] = useState(false);
  const [selectedQuoteForTeam, setSelectedQuoteForTeam] = useState({});
  const [showDQModal, setShowDQModal] = useState(false);
  const [isDownloadingQuote, setIsDownloadingQuote] = useState(false);
  const [selectedQuoteForDownload, setSelectedQuoteForDownload] = useState("");
  const [deleteConfirm, setDeleteConfirm] = useState(-1);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    companyName: "",
    vatNumber: "",
    addresses: "",
    finalTotalPrice: "",
    addressline1: "",
    addressline2: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
    subTotal: "",
  });
  const [editIndex, setEditIndex] = useState(-1);
  let email = localStorage.getItem("email");
  console.log(myQuotesState)

  const [selectedShippingMethodForDownloadQuote, setSelectedShippingMethodForDownloadQuote] = useState(1);
  const [isGenericUser, setIsGenericUser] = useState(true);

  useEffect(() => {

    (async () => {
      try {
        const id = localStorage.getItem("_id");
        const response = await checkGenericUser(id);
        if (response.success) {
          const { isGeneric } = response;
          console.log("Is Generic User :", isGeneric);
          setIsGenericUser(isGeneric);
        }
      } catch (error) {

      }
    })()

  }, []);

  const showDrawer = (id) => {
    setSelectedChatRefId(id);
  };

  const onClose = () => {
    setSelectedChatRefId(null);
  };

  const handleShipMethodChange = (id, shipMethodAtIndex) => {
    setSelectedShippingMethodForDownloadQuote(shipMethodAtIndex);
    let localShipMethodMap = selectedShipMethodMap;
    localShipMethodMap.set(id, shipMethodAtIndex);
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_SELECTED_SHIP_MAP,
      payload: localShipMethodMap,
    });
  };

  const handleTeamModal = async (selectedQuote) => {
    setSelectedQuoteForTeam(selectedQuote);
    setTeamMemberModalShow(true);
  };

  const updateQuoteData = (updatedQuote) => {
    let localQuotationsList = [...quotationsList];

    localQuotationsList.forEach((item) => {
      if (item.RefId == updatedQuote.RefId) {
        item.followers = updatedQuote.followers;
      }
    });
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_QUOTES_TO_SHOW,
      payload: localQuotationsList,
    });
  };



  const handleVersionDropDownClick = (event, index) => {
    let quoteToChange = myQuotesState.quotesToShow[index];
    let localQuotationsList = myQuotesState.quotesToShow;
    for (let i = 0; i < localQuotationsList.length; i++) {
      if (localQuotationsList[i].RefId == quoteToChange.RefId) {
        let newQuoteData = myQuotesState.quotationsRelatedToRefIds.filter(
          (element) =>
            element.RefId == localQuotationsList[i].RefId &&
            element.version == event.target.value
        );
        if (newQuoteData.length == 0) {
          toast.error("Something went wrong please refresh the page.");
          return;
        } else {
          localQuotationsList[i] = newQuoteData[0];
        }
      }
    }
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_QUOTES_TO_SHOW,
      payload: localQuotationsList,
    });
  };

  const handleEditClick = async (index) => {
    if (editIndex !== -1) {
      await new Promise((resolve) => {
        AntModal.error({
          title: 'Error',
          content: 'Cannot edit multiple projects at once',
          zIndex: 1000,
          onOk: () => resolve(),
        });
      });

      return;
    }

    let project = myQuotesState.quotesToShow[index];
    const firstUnderscoreIndex = project.projectName.indexOf("_");
    const editableText = project.projectName.substring(
      firstUnderscoreIndex + 1
    );
    setEditIndex(index);
    const updatedProjects = myQuotesState.quotesToShow.map((quote, i) =>
      i === index
        ? { ...quote, isEditing: true, previousProjectName: quote.projectName, editableProjectName: editableText }
        : quote
    );
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_QUOTES_TO_SHOW,
      payload: updatedProjects,
    });
  };

  const handleEditableChange = (e, index) => {
    const { value } = e.target;
    const updatedProjects = myQuotesState.quotesToShow.map((quote, i) =>
      i === index ? { ...quote, editableProjectName: value } : quote
    );
    console.log("Updated project name ::", updatedProjects);
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_QUOTES_TO_SHOW,
      payload: updatedProjects,
    });
  };

  const handleUpdateClick = async (index) => {

    const updatedProjects = await Promise.all(myQuotesState.quotesToShow.map(async (quote, i) => {
      if (i === index && quote.editableProjectName.trim() === "") {
        await new Promise((resolve) => {
          AntModal.error({
            title: 'Error',
            content: 'Project name cannot be empty',
            zIndex: 1000,
            onOk: () => resolve(),
          });
        }); // Show an alert or handle the error message
        return quote; // Return the original quote without changes
      } else if (i === index) {
        return {
          ...quote,
          isEditing: false,
          projectName: `${quote.projectName.split("_")[0]
            }_${quote.editableProjectName.trim()}`,
        };
      }
      return quote;
    }));

    console.log('New Updated Projects ::', updatedProjects);



    let updatedProject = updatedProjects[index];

    let data = {
      RefId: updatedProject.RefId,
      projectName: updatedProject.projectName,
    };
    console.log("Data for projectName :", data);

    try {
      const response = await handleProjectNameChange(token, data);


      if (!response.success) {
        throw new Error("")
      }
      toast.success(response.message);
      fetchQuotesForUser();

    } catch (error) {
      toast.error("Sorry, we are unable to update the project name at the moment. Please use the comment for further assistance.");
    } finally {

      setEditIndex(-1);
    }
  };

  const handleCancelClick = (index) => {
    const updatedProjects = myQuotesState.quotesToShow.map((quote, i) =>
      i === index
        ? { ...quote, isEditing: false, editableProjectName: "" }
        : quote
    );
    myQuotesDispatch({
      type: MY_QUOTE_ACTIONS.UPDATE_QUOTES_TO_SHOW,
      payload: updatedProjects,
    });
    setEditIndex(-1);
  };
  console.log("Active tab", activeTab);

  console.log("Selected Ref Id :", selectedChatRefId);
  return (
    <div className="table-container">
      <Chat
        RefId={selectedChatRefId}
        open={selectedChatRefId?.length > 0}
        onDrawerClose={onClose}
      />
      <TeamCollaboration
        teamMemberModalShow={teamMemberModalShow}
        selectedQuoteForTeam={selectedQuoteForTeam}
        setTeamMemberModalShow={setTeamMemberModalShow}
        fetchDataForUser={fetchQuotesForUser}
        updateQuoteData={updateQuoteData}
      />
      <DownloadQuotationModal
        show={showDQModal}
        selectedQuote={selectedQuoteForDownload}
        setShow={setShowDQModal}

      />
      <table className="table-fixed w-screen">
        <thead>
          <tr>
            <th className="info-text" style={{ width: `${widthBasedOnStatus[activeTab]}px`, borderLeft: "none" }}>Project Name </th>
            {
              activeTab === "all-quote-tab" ?
                <th className="info-text text-center" style={{ width: '170px' }}>Status</th> : null
            }
            <th className="info-text" style={{ width: '150px' }}>Process</th>
            <th className="info-text" style={{ width: '130px' }}>Owner</th>
            <th className="info-text" style={{ width: '130px' }}>Created On</th>
            <th className="info-text" style={{ width: '110px' }} >Version</th>
            {
              activeTab !== "inprogress" ?
                <>
                  <th className="info-text" style={{ width: '130px' }}>Rapid</th>
                  <th className="info-text" style={{ width: '130px' }}>Standard</th>
                  <th className="info-text" style={{ width: '130px' }}>Economy</th>
                </> : null
            }
            <th className="text-center" style={{ width: "80px" }}></th>
            {activeTab != 'inprogress' ? < th className="text-center" style={{ width: "80px" }}></th> : null}
          </tr>
        </thead>
        <tbody>
          {quotationsList.length > 0 &&
            quotationsList.map((item, i) => {
              console.log("Status :", item?.quotationStatus);

              return (
                <tr key={i}>
                  <td style={{ borderLeft: "none" }}>
                    <GlobalProjectNameComponent href={`/quote-versions/${item.RefId}?version=${item.version}`} project={item} index={i} handleEditClick={handleEditClick} handleEditableChange={handleEditableChange} handleUpdateClick={handleUpdateClick} handleCancelClick={handleCancelClick} />
                  </td>
                  {
                    activeTab === "all-quote-tab" ?
                      <td className="text-center">
                        {
                          (item?.quotationStatus && item?.quotationStatus?.length > 0) ?
                            <Badge pill className={`status-badge  ${item?.quotationStatus}`}>
                              {
                                item?.quotationStatus?.replace(/-/g, " ")
                              }
                            </Badge> : null
                        }
                      </td> : null
                  }
                  <td>
                    <p className="text">
                      {item?.selectedProcess ? processType[item?.selectedProcess - 1].name : null}
                    </p>
                    {/* <BrainMachine /> */}
                  </td>
                  <td>
                    <p className="text">{item?.userId?.firstName + " " + item?.userId?.lastName || ""}</p>
                    {/* <UserIcon /> */}
                  </td>
                  <td>
                    <p className="text text-center">{moment(item.createdAt).format("MMM DD, YYYY")}</p>
                    {/* <CalenderIcon /> */}
                  </td>
                  <td>
                    <Form.Select
                      style={{ fontSize: "13px", fontWeight: "400" }}
                      value={item.version}
                      onChange={(e) => handleVersionDropDownClick(e, i)}
                    >
                      {versionData[activeTab][item.RefId]?.map((item) => (
                        <option key={item?.version} value={item?.version}>
                          {item?.version}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                  {
                    activeTab !== "inprogress" ?
                      <>
                        <td>
                          {isShowPriceAccordingToProcess(item) ? (
                            <>
                              {item.price1 > 0 ? (
                                <>
                                  <p className="text">
                                    {item.price1
                                      ? currencyFormatter(
                                        (item.price1 + item.shippingCharge1 + item?.orderCertificationsCost).toFixed(
                                          2
                                        )
                                      )
                                      : 0}
                                  </p>
                                  <p className="info-text">
                                    {`${Number(item?.leadTime1 + item.shippingDays1)} `} Business days
                                  </p>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td>
                          {isShowPriceAccordingToProcess(item) ? (
                            <>
                              {item.price2 > 0 ? (
                                <>
                                  <p className="text">
                                    {item.price2
                                      ? currencyFormatter(
                                        (
                                          item.price2 + item.shippingCharge2 + item?.orderCertificationsCost
                                        ).toFixed(2)
                                      )
                                      : 0}
                                  </p>
                                  <p className="info-text">
                                    {`${Number(item?.leadTime2 + item.shippingDays2)} `} Business days
                                  </p>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td>
                          {isShowPriceAccordingToProcess(item) ? (
                            <>
                              {item.price3 > 0 ? (
                                <>
                                  <p className="text">
                                    {item.price3
                                      ? currencyFormatter(
                                        (
                                          item.price3 + item.shippingCharge3 + item?.orderCertificationsCost
                                        ).toFixed(2)
                                      )
                                      : 0}
                                  </p>
                                  <p className="info-text">
                                    {`${Number(item?.leadTime3 + item.shippingDays3)} `} Business days
                                  </p>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                      </> : null
                  }
                  <td>
                    <ChatButton
                      RefId={item.RefId}
                      showDrawer={() => showDrawer(item.RefId)}
                      isTextHide={true}
                      isNotShowText={true}
                      imageHeight={16}
                      textClasses='text-black ms-1'
                    />
                  </td>

                  {activeTab != 'inprogress' ? <td className="text-center">
                    {item?.quotationStatus != 'draft' ? <Dropdown className="options-dropdown">
                      <Dropdown.Toggle
                        className="link-btn"
                      >
                        <img src={moreIcon} alt="More" width={4} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>

                        {!isGenericUser ? <Dropdown.Item onClick={() => handleTeamModal(item)}>
                          <img
                            src={teamImage}
                            style={{
                              height: "18px",
                              cursor: "pointer",
                            }}
                          />
                          <p className="item">Team</p>
                        </Dropdown.Item> : null}
                        {(isShowPriceAccordingToProcess(item)) ?
                          <Dropdown.Item
                            onClick={() => {
                              setSelectedShippingMethodForDownloadQuote(1);
                              setSelectedQuoteForDownload(item);
                              setShowDQModal(true);
                            }}
                          >
                            <span>
                              <DownloadIcon additionalClass={'text-primaryColor'} />
                            </span>
                            <p className="item">Download</p>
                          </Dropdown.Item> : null
                        }
                      </Dropdown.Menu>
                    </Dropdown> : null}
                  </td> : null}


                  {/* <td className="text-center ">
                    <ChatButton
                      RefId={item.RefId}
                      showDrawer={() => showDrawer(item.RefId)}
                      isTextHide={true}
                      imageHeight={16}
                    />
                  </td>
                  <td className="">
                    <span onClick={() => handleTeamModal(item)} className="flex items-center justify-center">
                      <img
                        src={teamImage}
                        style={{
                          // marginRight: "5px",
                          // marginBottom: "4px",
                          height: "18px",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </td>}
                  <td style={{ textAlign: 'center' }}>
                  </td> */}
                  {/* <td style={{ textAlign: 'center' }}>
                    {(isShowPriceAccordingToProcess(item)) ?
                      <>
                        <span
                          onClick={() => {
                            setSelectedShippingMethodForDownloadQuote(1);
                            setSelectedQuoteForDownload(item);
                            setShowDQModal(true);
                          }}
                          className="grid place-items-center"
                        >
                          <DownloadIcon additionalClass={'text-primaryColor'} />
                        </span>
                      </>
                      :
                      <>
                      </>
                    }

                  </td>  */}
                </tr>
              );
            })}
        </tbody>
      </table>

      {
        quotationsList.length == 0 ? (
          <div
            className="text"
            style={{
              width: "100%",
              borderTop: "1px solid #ededed",
              minHeight: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {myQuotesState.searchQuery.length > 0
              ? "Oops! We couldn't find any quotes matching your search query."
              : "No Data Found"}
          </div>
        ) : (
          <></>
        )
      }
    </div >
  );
};

export default MyQuoteTable;
